module.exports = __webpack_public_path__ + "Flag-112.b207009e9b3dbd4b863006e107ca80bf.svg";